"use client"
import React from "react";
import { Container, Row, Col, Ratio } from "react-bootstrap";
import ProfileCoverPhoto from "@/components/shared/ProfileCoverPhoto";

import "@/components/maps/MapViewHero.css";
import { useMediaQuery } from "react-responsive";
import EventDateAndTime from "@/components/shared/EventDateAndTime";
import MapLink from "@/components/shared/MapLink";
import EventCTA from "@/components/events/EventCTA";

var moment = require("moment");

const MapViewHero = ({
  coverPhotoId,
  title,
  subtitle,
  text,
  event,
  startDate,
  endDate,
  multiDay,
  author,
  location,
  children
}) => {
  const isSm = useMediaQuery({ maxWidth: 767.98 });

  return (
    <Container className="map-view-hero">
      <Row>
        <Col>
          {coverPhotoId && (
            <>
              <div
                style={{
                  marginBottom: "1rem",
                  position: "relative",
                  height: isSm ? "unset" : "360px"
                }}
              >
                <ProfileCoverPhoto
                  coverPhotoId={coverPhotoId}
                  aspectRatio={"16x9"}
                  coverRatio={"3x1"}
                  maxHeight={isSm ? "unset" : "360px"}
                />
              </div>
            </>
          )}
          <div
            className="default-flex-row-layout"
            style={{ marginBottom: "1rem", alignItems: "flex-start" }}
          >
            <div
              className="default-flex-column-layout"
              style={{ gap: "0.5rem" }}
            >
              <h2>{title}</h2>
              {subtitle && <h4>{subtitle}</h4>}
            </div>
            <div className="flex-grow" />
            <div>
              <EventCTA event={event} />
            </div>
          </div>
          {event && event.startDate && (
            <div className="date-and-time">
              <EventDateAndTime
                startDate={startDate}
                endDate={endDate}
                multiDay={multiDay}
              />
            </div>
          )}
          {text && <p>{text}</p>}
          {location && <MapLink location={location} clickable={false} />}
        </Col>
      </Row>
      {children && (
        <Row>
          <Col>{children}</Col>
        </Row>
      )}
    </Container>
  );
};
export default MapViewHero;
